import {useContext} from "react";
import {NotificationsContext} from "../ui-components/Notifications";
import {useIntl} from "react-intl";
import {convertFromRaw} from "draft-js";
import {stateToHTML} from "draft-js-export-html";
import {getDateSlug} from "../utils/date";
import {stringToSlug} from "../utils/string";
import useCountryAxiosInstance from "./useCountryAxiosInstance";


const useWorksiteTaskPdfGenerator = (downloading, setDownloading) => {

  // context
  const { push } = useContext(NotificationsContext);

  // hooks
  const intl = useIntl();
  const apiRequest = useCountryAxiosInstance();

  const handler = async (taskData, includeActivitiesData, onDownload = null) => {

    if (downloading)
      return;

    setDownloading(true);
    try {
      const payload = taskData;

      if (includeActivitiesData && payload.activities?.length > 0) {
        // --- download all notes for each activity and convert their content to html
        const notes = await Promise.all(
          payload.activities.map((a) => {
            const params = {asc: 'created_at'};
            return apiRequest.get(`/worksites_notes/from_task_activity/${a.id}/all`, {params})
          })
        );
        payload.activities = payload.activities.map((a, idx) => {
          const parsedNotes = notes[idx].map((n) => ({
            author: n.val_author,
            created_at: n.created_at,
            edited_at: n.edited_at,
            content: stateToHTML(convertFromRaw(n.val_contents))}
          ));
          return {...a, notes: parsedNotes};
        });
        // --- tell the backend to retrieve the images and render them
        payload.include_images = true;
      }

      const options = {responseType: "blob"};
      const response = await apiRequest.post("/worksites_tasks/pdf", payload, options);
      if (onDownload) {
        return await onDownload(response, taskData);
      } else {
        // download pdf blob to file
        const url = URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${getDateSlug()}_${stringToSlug(taskData.title)}.pdf`;
        link.click();
        link.remove();
      }
    }
    catch (e) {
      push({type: 'error', title: intl.formatMessage({id: 'server_error'})});
      throw e;
    }
    finally {
      setDownloading(false)
    }
  }

  return handler;
};

export default useWorksiteTaskPdfGenerator;